// extracted by mini-css-extract-plugin
export default {"h1":"h1___S_xg4","button":"button___rkYbW","small":"small___pJb_G","disabled":"disabled___rjhNC"};